var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component, Inject } from "vue-property-decorator";
import Base from "../Base";
import DailySummary from "../promotions/eventGiveaway/components/DailySummary.vue";
import OutletList from "../merchant/OutletList.vue";
import ServicePoints from "../servicePoints/components/Summary.vue";
let default_1 = class default_1 extends Base {
    constructor() {
        super(...arguments);
        this.data = null;
    }
    mounted() {
        this.load();
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            this.data = null;
            this.data = yield post("/api/Service");
        });
    }
    getSummary(code) {
        return this.data.Promotions.find(p => p.CodeName == code);
    }
    bgfInfo() {
        this.alert("<div class='text-left'><ol><li>每台設備日費 2 點</li><li>計算區間：當日04:00～隔日03:59</li>" +
            "<li>收費方式（用前先收）：<br>設備當日首次開通即扣日費，如金額不足會提示無法啟用。<br>" +
            "每日00:00系統會統計開啟中的設備數，扣除設備日費，如金額不足即立即停止使用。在營收報表可以看到交易紀錄顯示加碼送點。</li>" +
            "<li>在leapa板螢幕上顯示再投五次就送一次。</li><li>投幾送包含投幣/掃碼支付/卡機支付/遠端投幣。</li></ol></div>", "付費說明", "warning");
    }
};
__decorate([
    Inject()
], default_1.prototype, "alert", void 0);
default_1 = __decorate([
    Component({ components: { OutletList, DailySummary, ServicePoints } })
], default_1);
export default default_1;
